import { useState } from "react";

interface NotificationSignupProps {
  isPopup?: boolean;
  onClose?: () => void;
}

export default function NotificationSignup({ isPopup = false, onClose }: NotificationSignupProps) {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    try {
      const response = await fetch("/api/notification-signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.success) {
        setIsSuccess(true);
        setEmail("");
      } else {
        setError(data.message || "Failed to sign up. Please try again.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      console.error("Error signing up for notifications:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`bg-white rounded-lg shadow-lg ${isPopup ? 'p-6' : 'p-4'}`}>
      <div className="text-center mb-4">
        <h3 className={`font-display font-bold ${isPopup ? 'text-2xl' : 'text-xl'} mb-2`}>
          Get Notified
        </h3>
        <p className="text-gray-600">
          Sign up to be notified when FerryPros is ready for users to start using it.
        </p>
      </div>

      {isSuccess ? (
        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded mb-4">
          Thank you! We'll notify you when FerryPros is ready.
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-gray-700 text-sm font-medium mb-1">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder="your@email.com"
              required
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <div className="flex justify-center">
            <button
              type="submit"
              disabled={isSubmitting}
              className="btn-primary bg-primary-600 text-white hover:bg-primary-700 text-base px-6 py-2 rounded-md"
            >
              {isSubmitting ? "Submitting..." : "Notify Me"}
            </button>

            {isPopup && onClose && (
              <button
                type="button"
                onClick={onClose}
                className="ml-2 btn-secondary bg-white text-gray-600 border border-gray-300 hover:bg-gray-100 text-base px-6 py-2 rounded-md"
              >
                No Thanks
              </button>
            )}
          </div>
        </form>
      )}
    </div>
  );
}
